import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaHotel, FaTaxi, FaPlane, FaChevronRight } from "react-icons/fa";
import { useTranslation } from "react-i18next";

// Assets
import hotelBg from "../../Assets/img/hotel_cat.png";
import taxiBg from "../../Assets/img/taxi_cat.png";
import vacationBg from "../../Assets/img/vacation_cat.png";

const BookingSearch = () => {
  const { t } = useTranslation();
  const categories = [
    {
      id: "Hotels",
      title: t('booking_luxury_hotels'),
      desc: t('booking_luxury_desc'),
      icon: <FaHotel />,
      image: hotelBg,
      link: "/hotels"
    },
    {
      id: "Taxi",
      title: t('booking_premium_taxi'),
      desc: t('booking_taxi_desc'),
      icon: <FaTaxi />,
      image: taxiBg,
      link: "/taxi"
    },
    {
      id: "Vacations",
      title: t('booking_explore'),
      desc: t('booking_explore_desc'),
      icon: <FaPlane />,
      image: vacationBg,
      link: "/khajuraho"
    }
  ];

  return (
    <div className="relative z-30 mt-8 lg:-mt-24 px-2 lg:px-12 mb-8 md:mb-20">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-3 gap-3 md:gap-6">
          {categories.map((cat) => (
            <Link key={cat.id} to={cat.link}>
              <motion.div
                whileHover={{ y: -8 }}
                className="group relative h-[160px] md:h-[380px] rounded-2xl md:rounded-[3rem] overflow-hidden cursor-pointer shadow-xl border-2 md:border-4 border-white"
              >
                {/* Background Image */}
                <img 
                  src={cat.image} 
                  alt={cat.title} 
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                {/* Overlay Gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/20 to-transparent group-hover:from-orange-main/80 transition-all duration-500" />
                
                {/* Content */}
                <div className="absolute inset-0 p-3 md:p-10 flex flex-col justify-end items-start">
                  <div className="w-9 h-9 md:w-14 md:h-14 bg-black/60 backdrop-blur-md rounded-xl md:rounded-[1.5rem] flex items-center justify-center text-white mb-2 md:mb-5 group-hover:rotate-[360deg] transition-all duration-700 shadow-xl border border-white/10">
                    <span className="text-sm md:text-2xl flex items-center justify-center">{cat.icon}</span>
                  </div>
                  
                  <div className="space-y-1 md:space-y-2 translate-y-2 md:translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                    <h3 className="text-[10px] md:text-2xl font-black text-white font-bold tracking-tight leading-none">{cat.title}</h3>
                    <p className="hidden md:block text-gray-300 text-[14px] font-mute tracking-widest leading-relaxed max-w-[300px]">
                      {cat.desc}
                    </p>
                  </div>
                  
                  <div className="hidden md:flex mt-6 items-center gap-3 text-white font-black text-[10px] uppercase tracking-[0.2em] opacity-0 group-hover:opacity-100 transition-all duration-500">
                    {t('booking_explore_btn')} 
                    <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center group-hover:bg-white group-hover:text-orange-main transition-colors">
                      <FaChevronRight size={10} />
                    </div>
                  </div>
                </div>
              </motion.div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BookingSearch;
